<template>
  <div class="custom-container">
    <div class="ms-cell-editor text text-overflow" :class="{'cell-error': errorMessage}">
      <div
        v-show="!isSelected || readOnly"
        ref="cellEditor"
        :class="{
          'edit-disabled': readOnly,
          'ms-editor-text': editable,
          hasError: errorProvider.isValid,
          'display-error': errorMessage && !isEditor && displayError,
        }"
      >
        <!-- <div class="editor-display" v-if="!isEditor">
          
        </div> -->
        <a v-show="!isEditor" @click="$emit('editorClick', $event, col, colIndex)" class="editor-click">
          <span
            class="editor-display"
            :class="[textAlign ? textAlign : '', col.linkedForm && col.linkedForm != '' ? 'text-link' : '']"
            :title="[
              dataRow[col.dataField]
                ? $ms.format.formatData(dataRow[col.dataField], {
                    formatType: col.formatType,
                  })
                : '',
            ]"
            >{{
              dataRow[col.dataField]
                ? $ms.format.formatData(dataRow[col.dataField], {
                    formatType: col.formatType,
                  })
                : ''
            }}</span
          >
        </a>

        <ms-textarea
          v-model="cellData"
          v-if="isEditor"
          class="text-area-grid"
          v-on="customListener"
          :maxLength="propsData?.maxLength"
          :textAlign="textAlign"
          :autoRows="true"
          :preventPaste="allowCopyFromExcel"
          :rows="1"
        >
        </ms-textarea>

        <div class="icon24 error" v-show="errorMessage && !isEditor && displayError" v-tooltip="errorMessage"></div>
        <!-- Thêm icon sau input -->
        <div
          class="icon24 suffix-icon"
          :class="{
            disabled: disabled,
            more: (col.suffixIconType == null) | (col.suffixIconType == $ms.constant.SuffixIconType.More),
            view: col.suffixIconType == $ms.constant.SuffixIconType.View,
            'edit-pencil': col.suffixIconType == $ms.constant.SuffixIconType.Edit,
            'alway-show': col.isAlwayShow,
          }"
          v-if="
            (propsData.isSuffixIcon && !isEditor) ||
            (typeof col.isSuffixIcon == 'function' ? col.isSuffixIcon(dataRow, col) : col.isSuffixIcon)
          "
          @click.stop="
            () => {
              (typeof propsData.suffixClick == 'function' && propsData.suffixClick(dataRow, col)) ||
                (typeof col.suffixClick == 'function' && col.suffixClick(dataRow, col));
            }
          "
        ></div>
      </div>
    </div>

    <v-menu
      ref="optionMenu"
      class="option-wrapper"
      v-if="isEditor && isCopyDataColumn"
      popperClass="option-menu"
      :placement="isAtLastColumn ? 'bottom-start' : 'bottom-end'"
      :skidding="marginSetting"
      :width="menuContentWidth"
      :style="[{right: isAtLastColumn ? 'auto' : optionMenuRight}, {left: isAtLastColumn ? optionMenuLeft : 'auto'}]"
      @show="handleMenuShow"
      :class="dbOptionHeight"
    >
      <div :class="['icon24', 'option-tab-vertical', 'option-custom']"></div>
      <template #popper>
        <menu-item
          v-for="(item, i) in editorActions"
          :key="i"
          @menu-item-click="clickMenuItem(item.id, rowIndex, colIndex)"
          >{{ item.text }}</menu-item
        >
      </template>
    </v-menu>
  </div>
</template>
<script>
import {defineProps, getCurrentInstance, defineEmits, watch, nextTick, defineExpose, ref, computed, inject} from 'vue';
import {useCellEditor} from './CellEditorSetup.js';
import MenuItem from '@/components/dropdown/MenuItem.vue';
export default {
  name: 'MsCellTextarea',
  components: {
    MenuItem,
  },
  props: {
    col: {},
    dataRow: {},
    rowIndex: {
      default: 0,
      type: Number,
    },
    colIndex: {
      default: 0,
      type: Number,
    },
    //Thuộc tính để cấu hình cho phép sửa trên grid hay không
    editable: {
      default: true,
      type: Boolean,
    },
    rowSelected: {
      default: null,
    },

    readOnly: {
      default: false,
      type: Boolean,
    },
    //có cho phép show text validate bên dưới cell k
    isShowText: {
      type: Boolean,
      default: false,
    },
    propsData: {
      type: Object,
      default: () => {},
    },
    rules: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // Hiện thị số dòng cho phép.
    lineBreak: {
      default: 1,
      type: Number,
    },
    /**
     * Cấu hình sao chép dữ liệu 1 cột xuống các cột khác (mục đích để dev phải check lại các màn hình đã làm để tránh lỗi dữ liệu)
     * dtnga3 (26.05.2023)
     */
    isCopyDataColumn: {
      default: false,
      type: Boolean,
    },
    optionMenuRight: {
      default: null,
      type: String,
    },
    optionMenuLeft: {
      default: null,
      type: String,
    },
    // Đánh dấu control nằm ở cột cuối hay không
    // dtnga3
    isAtLastColumn: {
      default: false,
      type: Boolean,
    },
    // Độ rộng menu content (cần set để tính toán vị trí của nó)
    // dtnga3
    menuContentWidth: {
      default: 194,
      type: Number,
    },
    textAlign: {
      default: null,
      type: String,
    },
  },
  emits: ['editorClick', 'msKeydown', 'update:modelValue', 'copyActionClick', 'pasteInput', 'pasteInput'],

  setup(props, {emit}) {
    const {proxy} = getCurrentInstance();

    const {
      isEditor,
      errorProvider,
      isSelected,
      listeners,
      activeCell,
      inactiveCell,
      cellData,
      findEditor,
      errorMessage,
      validate,
      getValue,
      clearValidate,
      displayError,
      editorActions,
      clickMenuItem,
      marginSetting,
      handleMenuShow,
    } = useCellEditor({
      props,
      emit,
    });

    const customListener = computed(() => {
      return {
        ...(listeners?.value ?? {}),
        [proxy.$ms.constant.CustomEvent.MsKeydown]: (e, value) => {
          if (e.keyCode == proxy.$ms.constant.KeyCode.Enter && e.shiftKey) {
            e.stopPropagation();
            // emit sự kiện xuống dòng ở đây
          } else {
            emit(proxy.$ms.constant.CustomEvent.MsKeydown, e, value);
          }
        },
      };
    });

    const isCellEditor = inject('isCellEditor');
    const allowCopyFromExcel = inject('allowCopyFromExcel');

    watch(isEditor, newVal => {
      if (!newVal) {
        emit('update:modelValue', cellData.value);
      } else {
        cellData.value = props.dataRow[props.col.dataField];
        nextTick(() => {
          findEditor();
        });
      }
    });

    /**
     * Gán giá trị cho cell
     */
    const setValue = value => {
      let me = proxy;

      if (typeof isCellEditor == 'function' && !isCellEditor(props.col, props.dataRow)) {
        return;
      }

      if (me.readOnly) {
        return;
      }
      if (me.propsData?.maxLength && value?.length > me.propsData?.maxLength) {
        value = value.substring(0, proxy.maxLength);
      }
      cellData.value = value;
      emit('update:modelValue', cellData.value);
    };

    const dbOptionHeight = computed(() => {
      return (
        'heightoptionvalue' +
        parseInt(
          proxy.$store?.state?.dbOption?.dbOptions.HeightOption == 1
            ? proxy.$store?.state?.dbOption?.dbOptions.HeightOption
            : 0,
        )
      );
    });
    return {
      isEditor,
      errorProvider,
      isSelected,
      customListener,
      activeCell,
      inactiveCell,
      cellData,
      findEditor,
      errorMessage,
      validate,
      getValue,
      clearValidate,
      displayError,
      editorActions,
      clickMenuItem,
      marginSetting,
      handleMenuShow,
      dbOptionHeight,
      setValue,
      allowCopyFromExcel,
    };
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/components/CellAction.scss';
.mi-icon-error {
  margin-right: 8px;
}

.ms-cell-editor {
  .suffix-icon {
    display: none;
    border-left: 1px solid $secondary;
    height: 100%;
    width: 0px;
    padding-right: 28px;
    &::before {
      top: 50%;
      left: 50%;
      transform: translateY(-50%) translateX(-50%);
    }
    &.disabled {
      pointer-events: none;
    }
  }
  .suffix-icon.alway-show {
    display: block;
  }
  &:hover {
    .suffix-icon {
      display: block;
    }
  }
  .editor-display {
    white-space: pre;
  }

  .editor-display.center {
    text-align: center;
  }
}
</style>
